<div class="row">
  <div class="col-lg-9">
    <h1>Application Login Statistics</h1>
    <span class="d-block" style="font-size: 15px;color: blue;"> (For last 365 days)</span>
  </div>

</div>
<div>
  <h4>{{selectedApplication}}</h4>
</div>
<div class="row mt-3">
  <div class="col-sm-12">
    <div class="card-block">
      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs" (activeIdChange)="onTabchange($event)" #tabs>
        <li ngbNavItem="successful">
          <a ngbNavLink>Successful Logins</a>
          <ng-template ngbNavContent>

            <div align="center" class="dataTables_wrapper" margin>
              <br>
              <app-custom-table #successLoginLogs (dtAjaxCall)="dtAjaxCallSuccess($event);"
                (onRowInit)="onRowInit($event);" [columnList]="columnListSuccess" [dtOptions]="dtOptionsSuccess">
              </app-custom-table>
            </div>
          </ng-template>
        </li>
        <li ngbNavItem="failed">
            <a ngbNavLink>
              Failed Logins
            </a>

            <ng-template ngbNavContent>
              <div align="center" class="dataTables_wrapper" margin>
                <br>
                <app-custom-table #failedLoginLogs (dtAjaxCall)="dtAjaxCallFailed($event);"
                  (onRowInit)="onRowInit($event);" [columnList]="columnListFailed" [dtOptions]="dtOptionsFailed">
                </app-custom-table>
              </div>
            </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
      <!-- </div> -->
    </div>
  </div>
</div>


<ng-template #content class="modal-dialog" let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}} Login Details for {{applicationName}}</h4>
    <button (click)="d('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table border="1" cellpadding="5" cellspacing="0" class="table" class="row-border hover"
      style="table-layout: fixed;" width="100%">
      <thead class="thead-default">
        <tr>
          <th style="text-align: left">Details</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let reason of failureReasons">
          <td align="left" style="word-wrap: break-word;">{{reason}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button (click)="c('Close click')" class="btn btn-outline-dark" type="button">Close</button>
  </div>
</ng-template>
